import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wildcard'
})
export class WildcardPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace('%','*');
  }
}
